module.exports = __webpack_public_path__ + "static/media/L_02_sp.6189e3f2.jpg";